import { NewContractorGetters } from './new-contractor.keys';

export const getInitialState = () => {
  return {
    newContractor: {
      entity: '',
      pay_to_name: '',
      sin: '',
      ssn: '',
      gst: '',
      qst: '',
      hst: '',
      is_aoda: false,
      aoda_code: '',
      backcheck_date: null,
      health_and_safety_date: null,
      workplace_violence_date: null,
      whmis: null,
      whmis_ghs: null,
      is_cpp: false,
      is_verified: false,
      source: '',
      source_note: '',
      general_comments: '',
      external_notes: '',
      payroll_nums: [],
      user: {
        first_name: '',
        last_name: '',
        preferred_name: '',
        is_active: true,
        email: '',
        email_alt: '',
        phone1: '',
        phone1_type: null,
        phone2: '',
        phone2_type: null,
        phone3: '',
        phone3_type: null
      },
      address: {
        line1: '',
        line2: '',
        city: '',
        province_abbr: '',
        postal_code: ''
      },
      sin_expiry: null
    }
  };
};

export const newContractorStore = {
  state: getInitialState,
  getters: {
    [NewContractorGetters.NewContractor]: state => {
      return state.newContractor;
    }
  }
};
